import { render, staticRenderFns } from "./ImpressionPixel.vue?vue&type=template&id=8fab89fa"
import script from "./ImpressionPixel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpressionPixel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports